import storage from './storage';

const ATTORNEY = 'Attorney';
const PARALEGAL = 'Paralegal';
const ABSTRACTOR = 'Abstractor';
const LEGAL_ASSISTANT = 'Legal Assistant';
export const TRYON_EMPLOYEE = 'Tryon Employee';
export const TITLES = [
    ATTORNEY,
    PARALEGAL,
    ABSTRACTOR,
    LEGAL_ASSISTANT,
    TRYON_EMPLOYEE
];
export const LAW_FIRM_ADMIN = 'Law Firm Admin';
export const LAW_FIRM_USER = 'Law Firm User';
export const TRYON_SITE_ADMIN = 'Tryon Site Admin';
export const TRYON_USER = 'Tryon User';
export const TRYON_BOT = 'Tryon Bot';

export const ROLES_ID_MAP = Object.freeze({
    [TRYON_SITE_ADMIN]: 1, 
    [TRYON_USER]: 2,
    [LAW_FIRM_ADMIN]: 3,
    [LAW_FIRM_USER]: 4,
    [TRYON_BOT]: 5
});

/**
 * User Roles
 * @readonly
 * @enum {number}
 */
export const ROLES = Object.freeze({
    ADMIN: 1, 
    TRYON: 2,
    FIRM_ADMIN: 3,
    FIRM_USER: 4,
    TRYON_BOT: 5
});

/**
 * Determins if the userRole meets the requiredRole
 * @param {ROLES} userRole 
 * @param {ROLES} requiredRole 
 * @returns {boolean}
 */
export const checkRole = (userRole, requiredRole) => {
    if (requiredRole == null)
        return true;

    const roleMatchers = {
        [ROLES.ADMIN]: /^1$/,
        [ROLES.TRYON]: /^(?:1|2)$/,
        [ROLES.FIRM_ADMIN]: /^(?:1|3)$/,
        [ROLES.FIRM_USER]: /^(?:1|3|4)$/,
        [ROLES.TRYON_BOT]: /^(?:1|2|5)$/,
    };

    return roleMatchers[requiredRole].test(userRole);
};

export const isLawFirm = (userRole) => {
    return [ROLES.FIRM_USER, ROLES.FIRM_ADMIN]
        .includes(userRole);
};

export const isTryon = (userRole) => {
    return [ROLES.TRYON, ROLES.ADMIN, ROLES.TRYON_BOT]
        .includes(userRole);
};

export const isTryonBot = (userRole) => {
    return [ROLES.TRYON_BOT]
        .includes(userRole);
};

export const getToken = () => {
    const token = storage.getItem('trt.token', null);
    return token;
};

export const setToken = (token) => storage.setItem('trt.token', token);

export const clearToken = () => storage.removeItem('trt.token');

export const decode = (token) => {
    if (!token) return null;

    const [, payload, ] = token.split('.');
    let decoded = JSON.parse(atob(payload));
    return decoded;
};

export const isTokenExpired = () => {
    const token = getToken();
    const decoded = decode(token);

    return (decoded.exp <= (new Date().getTime() / 1000));
};

export const isTokenValid = () => !isTokenExpired();

/**
 * Returns list of roles for a given title
 * @param {TITLES} title 
 * @returns {[ROLES]}
 */
export const getRolesByTitle = (title) => {
    const rolesByTitle = {
        [ATTORNEY]:         [ ROLES.FIRM_ADMIN ],
        [PARALEGAL]:        [ ROLES.FIRM_USER ],
        [ABSTRACTOR]:       [ ROLES.FIRM_USER ],
        [LEGAL_ASSISTANT]:  [ ROLES.FIRM_USER ],
        [TRYON_EMPLOYEE]:   [ ROLES.TRYON, ROLES.ADMIN, ROLES.TRYON_BOT ],
    };
  
    return Object.keys(rolesByTitle).includes(title)
        ? rolesByTitle[title]
        : [];
};

export const getRoleNameByRoleId = (roleId) => {
    return Object.entries(ROLES_ID_MAP).find(role=>role[1] === roleId)[0];
};

export const isStrongPassword = (pw) => (
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=\s{0,})(?=[-_<>!@#$%^&*?]{0,})(?=.*)[A-Za-z\d\s\-_<>!@#$%^&*?]{8,}$/.test(pw)
);

export const generateTempPassword = () => {
    const lower = 'abcdefghijklmnopqrstuvwxyz';
    const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numeral = '0123456789';
    const special = '-_!@#$%^&*?';

    let pw = '';

    while (!isStrongPassword(pw)) {
        pw += lower.charAt(Math.random() * lower.length);
        pw += upper.charAt(Math.random() * upper.length);
        pw += numeral.charAt(Math.random() * numeral.length);
        pw += special.charAt(Math.random() * special.length);
    }

    return pw;
};

export default {
    getToken,
    setToken,
    clearToken,
    decode,
    isTokenExpired,
    isTokenValid,
    isStrongPassword,
    generateTempPassword,
    ROLES,
    TITLES,
    getRolesByTitle,
    getRoleNameByRoleId,
    checkRole,
    isLawFirm,
    isTryon,
    isTryonBot,
    LAW_FIRM_ADMIN,
    LAW_FIRM_USER,
    TRYON_SITE_ADMIN,
    TRYON_USER,
    TRYON_BOT,
    ROLES_ID_MAP
};